import React from 'react'
import { connect } from 'react-redux'
import { withApollo } from 'react-apollo'

import {
  Segment,
  Form,
  Grid,
} from 'components/UI'
import ProfileEdit from './ProfileEdit'
import Auth from 'store/Auth'

function handleLogout (logout, client) {
  logout()
  client.resetStore()
}

const ProfileCard = ({ info, logout, client }) => (
  <Segment>
    <Grid.Row fitted>
      <Grid.Col width={4}>
        <Form.Text
          label='First Name'
          value={info.givenName}
          disabled
        />
        <Form.Text
          label='Last Name'
          value={info.familyName}
          disabled
        />
        <Form.Text
          label='Email'
          value={info.email}
          disabled
        />
        <Form.Text
          label='Phone Number'
          value={info.phoneNumber}
          disabled
        />
      </Grid.Col>
      <Grid.Col>
        <Form.Actions>
          <Form.Button onClick={() => handleLogout(logout, client)}>
            Logout
          </Form.Button>
          <ProfileEdit info={info} />
        </Form.Actions>
      </Grid.Col>
    </Grid.Row>
  </Segment>
)

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(Auth.logout()),
})

export default connect(null, mapDispatchToProps)(withApollo(ProfileCard))



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileCard.jsx